(ns renolit-roofing-service.tooltip.generic-popup
  (:require [re-frame.core :as rf]
            [renolit-roofing-service.data-loading :as data-loading]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.tooltip :as tooltip]
            [renolit-roofing-service.util :as util]))

(def ^:const default-popup-id "generic-popup")

(def ^:const ^:private default-data
  {:modal? false
   :lightbox? true
   :argv []})

(defn main
  ([]
   (main default-popup-id))
  ([popup-id]
   (let [popup-data (rf/subscribe [::tooltip/by-id popup-id])]
     (fn []
       (when (:component @popup-data)
         (let [{:keys [component argv class]}
               (merge default-data @popup-data)]
           [:div.generic-popup-container
            tooltip/disable-event-propagation-props
            [:div.generic-popup
             {:class (cond-> [(tooltip/gen-controller-class popup-id)]
                       (string? class)
                       (conj class)

                       (sequential? class)
                       (concat class))}
             (into [component] argv)]]))))))

(defn generic-back-button
  [{:keys [label-transl-kw on-click]}]
  [:button.flat-btn.generic-popup__back-btn
   {:type "button"
    :on-click #(util/execute-callback on-click)}
   [layout.icon/icon
    {:key :back}]
   (t [(or label-transl-kw :common/back)])])

(defn generic-popup-header
  [{:keys [popup-id icon icon-key title title-transl-kw]}]
  [:div.generic-popup__header
   (when icon-key
     [layout.icon/icon
      {:key icon-key}])
   (when icon
     icon)
   (when (or title title-transl-kw)
     [:h1.generic-popup__title
      (or title (t [title-transl-kw]))])
   [:button.flat-btn
    {:type "button"
     :auto-focus true
     :on-click #(rf/dispatch [::tooltip/destroy-by-id
                              {:id (or popup-id default-popup-id)}])}
    [layout.icon/icon
     {:key :close}]]])

(defn generic-popup-footer
  [{:keys [popup-id on-cancel on-accept extra-buttons]}]
  [:div.generic-popup__footer
   (when on-cancel
     [:button.btn.btn--tertiary
      {:on-click
       (fn [_]
         (util/execute-callback on-cancel)
         (when-not (:prevent-default? on-cancel)
           (rf/dispatch [::tooltip/destroy-by-id {:id (or popup-id default-popup-id)}])))}
      (t [:common/cancel])])
   [:div.generic-popup__footer-button-group
    (doall
     (for [[idx {:keys [icon-kw label-transl-kw on-click disabled]}]
           (map-indexed vector extra-buttons)]
       ^{:key (str "gp-footer-button_" idx)}
       [:button.btn.btn--secondary.generic-popup__footer-btn
        (cond->
         {:on-click #(util/execute-callback on-click)}
          disabled
          (assoc :disabled true
                 :class "btn--disabled"))
        (when icon-kw
          [layout.icon/icon
           {:key icon-kw}])
        (t [label-transl-kw])]))
    (when on-accept
      [:button.btn.btn--primary
       (cond-> {:on-click #(util/execute-callback on-accept)}
         (:disabled on-accept)
         (assoc :disabled true
                :class "btn--disabled"))
       (if-let [label-kw (get on-accept :label-transl-kw)]
         (t [label-kw])
         (t [:common/next]))])]])

(defn generic-confirmation-popup
  [{:keys [title-transl-kw
           line-1-transl-kw line-1-transl-args
           line-2-transl-kw line-2-transl-args
           on-cancel on-accept
           loading-evt-id]}]
  (let [loading? (rf/subscribe [::data-loading/loading loading-evt-id])]
    (fn []
      [:<>
       [generic-popup-header
        {:title-transl-kw title-transl-kw}]
       [:div.generic-confirmation-popup
        [:p.generic-confirmation-popup__body
         (t [line-1-transl-kw] line-1-transl-args)]
        [:p.generic-confirmation-popup__body
         (t [line-2-transl-kw] line-2-transl-args)]]
       [generic-popup-footer
        {:on-cancel (merge {:disabled @loading?} on-cancel)
         :on-accept (merge {:disabled @loading?
                            :label-transl-kw :common/accept-continue} on-accept)}]])))
